import styled from 'styled-components';
import { Typography } from 'ui';

export const ClearCacheButtonStyled = styled(Typography)`
  color: var(--color-fireEngineRed);
`;
